import React from "react";
import { Tag, Tooltip } from "antd";
import { useMediaQuery } from 'react-responsive'

const Events = (data) => {
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-device-width: 1224px)'
    })
    const isBigScreen = useMediaQuery({ query: '(min-device-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1500px)' })
    const isTabletOrMobileDevice = useMediaQuery({
        query: '(max-device-width: 1224px)'
    })

    return (
        data.data?.map((item, index) => {
            return isTabletOrMobile ?
                <div key={index} style={{ width: '100%' }} className="gx-media gx-featured-item">
                    <div className="gx-featured-thumb">
                        {item.firmName}
                    </div>
                    <div className="gx-media-body gx-featured-content">
                        <div className="gx-featured-content-left" style={{ color: 'black', fontSize: 12 }}>
                            {item.eInvoiceNumber} - {item.senario} - {item.type}
                            <h3 className="gx-mb-2"></h3>
                            <div className="ant-row-flex">
                                <div className="gx-media gx-text-grey gx-mb-1">
                                    <img src={require(`assets/images/Icons/Calendar.svg`)} alt="icon" style={{ width: 23, height: 23 }} />
                                    <span className="gx-media-body gx-ml-1" style={{ fontSize: 12, width: 203 }}>{item.dateFormat}</span>
                                </div>
                            </div>
                        </div>
                        <div className="gx-featured-content-right gx-profile-content-right">
                            <h4 className="gx-text-primary gx-mb-1">
                                <span
                                    className="gx-d-inline-flex gx-vertical-align-middle" >

                                    {!item.isOut && data.IsEInvoice ?
                                        <p style={{ color: "red", fontSize: 12, width: 70, whiteSpace: 'nowrap' }}>
                                            {data.isDigitHomePage ? item.totalAmountString : item.totalAmountString.toString().split(",")[0]}
                                        </p>
                                        :
                                        <p style={{ color: "green", fontSize: 12, width: 70, whiteSpace: 'nowrap' }}>
                                            {data.isDigitHomePage ? item.totalAmountString : item.totalAmountString.toString().split(",")[0]}</p>}

                                </span>
                            </h4>
                        </div>
                    </div>
                </div>
                : <div key={index} style={{ width: '100%' }} className="gx-media gx-featured-item">
                    <div className="gx-featured-thumb">
                        {item.firmName}
                    </div>
                    <div className="gx-media-body gx-featured-content">
                        <div className="gx-featured-content-left">
                            {item.eInvoiceNumber} - {item.senario} - {item.type}
                            <h3 className="gx-mb-2"></h3>
                            <div className="ant-row-flex">
                                <div className="gx-media gx-text-grey gx-mb-1">
                                    <img src={require(`assets/images/Icons/Calendar.svg`)} alt="icon" style={{ width: 23, height: 23 }} />
                                    <span className="gx-media-body gx-ml-1">{item.dateFormat}</span>
                                </div>
                            </div>
                        </div>
                        <div className="gx-featured-content-right gx-profile-content-right">
                            <h4 className="gx-text-primary gx-mb-1">
                                <span
                                    className="gx-d-inline-flex gx-vertical-align-middle" >

                                    {!item.isOut && data.IsEInvoice ?
                                        <p style={{ color: "red", whiteSpace: 'nowrap' }}>
                                            {data.isDigitHomePage ? item.totalAmountString : item.totalAmountString.toString().split(",")[0]}
                                        </p>
                                        :
                                        <p style={{ color: "green", whiteSpace: 'nowrap' }}>
                                            {data.isDigitHomePage ? item.totalAmountString : item.totalAmountString.toString().split(",")[0]}</p>}

                                </span>
                            </h4>
                        </div>
                    </div>
                </div>
        })
    );
}

export default Events;
